var _stop, _stop2, _stop3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgBlur = function SvgBlur(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: _id,
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 80 -80 0 80 80)",
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0.114,
    stopColor: "#17D3FF",
    stopOpacity: 0.3
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#08E2B8",
    stopOpacity: 0.1
  })), _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90",
    stopOpacity: 0
  })))));
};
export default SvgBlur;